module.exports = __webpack_public_path__ + "media/fonts/FiraSans-Bold-3919333f2e366bb4341e09929ea31d60.ttf";